import { useMutation } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";

import { getClient } from "services";

import { deleteSubscription } from "seneca-common/features/subscriptions/state/actions";
import { analyticsLogReassignSubscription } from "seneca-common/features/subscriptions/state/analytics";
import { isSignedIn } from "seneca-common/features/user/state";

import { useGetChildrenActiveSubscriptions } from "./useFetchChildrenSubscriptions";

export default function useReassignSubscription() {
  const isUserSignedIn = useSelector(isSignedIn);

  const { refetch: refetchChildrenSubscriptions } =
    useGetChildrenActiveSubscriptions({ enabled: isUserSignedIn });

  const dispatch = useDispatch();

  return useMutation({
    mutationKey: ["reassignSubscription"],
    mutationFn: async ({
      reassignToUserId,
      subscriptionId
    }: {
      reassignToUserId: string;
      subscriptionId: string;
    }) => {
      await getClient("parentsService").reassignSubscriptionToChild({
        subscriptionId,
        reassignToUserId
      });
      return { subscriptionId, reassignToUserId };
    },
    onSuccess: ({ subscriptionId, reassignToUserId }) => {
      analyticsLogReassignSubscription(reassignToUserId);
      refetchChildrenSubscriptions();
      dispatch(deleteSubscription(subscriptionId));
    }
  });
}
